import { Route, Routes } from "react-router-dom";
import Layout from "./layout/layout";
import LandingPage from "./screens/landingPage";
import SignIn from "./screens/signIn";
import SignUp from "./screens/signUp";
import ResetPassword from "./screens/resetPassword";
import ReplacePassword from "./screens/replacePassword";
import ConfirmOTP from "./screens/confirmOTP";
import ConfirmAuthOTP from "./screens/confirmAuthOTP";
import ProtectedRoute from "./utils/protectedRoute";
import DashboardLayout from "./layout/dashboard/dashboardLayout";
import Overview from "./screens/overview";
import Launch from "./components/launch/launch";
import MyTrucks from "./screens/myTrucks";
import MyDrivers from "./screens/myDrivers";
import CompleteProfile from "./screens/completeProfile";
import ViewProfile from "./screens/viewProfile";
import Dashboard from "./screens/dashboard";
import LoadList from "./screens/loadList";
import NewDashboardLayout from "./layout/dashboard/newDashboardLayout";
import AvailableLoad from "./screens/availableLoads";
import PostLoad from "./screens/postLoad";
import UpdateProfile from "./screens/updateProfile";

function App() {
  return (
    <Routes>
        <Route path="/" element={<LandingPage />} />
      {/* Public Routes */}
      <Route element={<Layout />}>
        <Route path="/signIn" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/replace-password" element={<ReplacePassword />} />
        <Route path="/confirm-OTP" element={<ConfirmOTP />} />
        <Route path="/confirm-auth-OTP" element={<ConfirmAuthOTP />} />
      </Route>

      <Route path="/launch" element={<Launch />} />

      {/* Protected Routes */}
      <Route element={<ProtectedRoute />}>

        <Route element={<NewDashboardLayout/>} >

          <Route path="/overview" element={<Overview />} />

          <Route path="/dashboard" element={<Dashboard/>} />

          <Route path="/view-profile" element={<ViewProfile/>} />

          <Route path="/available-loads" element={<AvailableLoad />} />

          <Route path="/complete-profile" element={<CompleteProfile />} />

          <Route path="/post-load" element={<PostLoad />} />

          <Route path="/myTrucks" element={<MyTrucks />} />

          <Route path="/driver" element={<MyDrivers />} />

          <Route path="/update-profile" element={<UpdateProfile />} />

          {/* MY AUTOLOADS */}
          <Route path="/loads" element={<LoadList/>} />

        </Route>


        <Route element={<DashboardLayout />}>        
   
        </Route>
        
      </Route>
    </Routes>
  );
}

export default App;